import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  us: {
    translation: {
      'United States': 'United States',
      Vietnam: 'Vietnam',
      'Khách hàng': 'Customers',
      'Chinh phục thử thách': 'Challenges',
      'Thêm mới': 'News',
      'Trạng thái': 'Status',
    },
  },
  vn: {
    translation: {
      'United States': 'United States',
      Vietnam: 'Việt Nam',
      'Khách hàng': 'Khách hàng',
      'Chinh phục thử thách': 'Chinh phục thử thách',
      'Thêm mới': 'Thêm mới',
      'Trạng thái': 'Trạng thái',
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'vn', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
